import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert, Spinner } from "reactstrap";
import axios from "axios";
import { API_URL_partners } from "../../constants";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { getAuthHeaders } from "../../utils/auth";
class NewPartnerForm extends React.Component {

  state = {
    pk: 0,
    partner_code: "",
    partner: "",
    nivel:'',
    email: "",
    grupo:'',
    localizacion:'',
    ingreso_date:'',
    cumple_date:'',
    errorMessage: '',
    validationErrors: {},
    isSubmitting: false,
  };

  componentDidMount() {
    if (this.props.partner) {
      const {
      pk,
      partner_code,
      partner,
      nivel,
      email,
      grupo,
      localizacion,
      ingreso_date,
      cumple_date,
      iva,
      retencion,
      isr,
      } = this.props.partner;

      const formattedIngresoDate = ingreso_date ? new Date(ingreso_date) : null;
      const formattedCumpleDate = cumple_date ? new Date(cumple_date) : null;


      this.setState({
        pk,
        partner_code,
        partner,
        nivel,
        email,
        grupo,
        localizacion,
        ingreso_date: formattedIngresoDate,
        cumple_date: formattedCumpleDate,
        iva,
        retencion,
        isr,
      });
    }
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  validateForm = () => {
    const errors = {};
    const { partner } = this.state;

    if (!partner || partner.trim() === '') {
      errors.partner = 'Por favor ingresa el nombre del miembro';
    }

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  createPartner = e => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();
    axios.post(API_URL_partners, this.state, { headers })
    .then(() => {
      this.props.resetState();
      this.props.toggle();
    }).catch(error => {
      console.log(error);
      if (error.response?.data) {
        const serverErrors = error.response.data;
        if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
          this.setState({ validationErrors: serverErrors, isSubmitting: false });
        } else {
          this.setState({
            errorMessage: 'Error al crear el partner. Por favor verifica los datos.',
            isSubmitting: false
          });
        }
      } else {
        this.setState({
          errorMessage: 'Error de conexión. Por favor intenta nuevamente.',
          isSubmitting: false
        });
      }
    });
  };

  editPartner = e => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();
    axios.put(`${API_URL_partners}${this.state.pk}/`, this.state, { headers })
    .then(() => {
      this.props.resetState();
      this.props.toggle();
    }).catch(error => {
      console.log(error);
      if (error.response?.data) {
        const serverErrors = error.response.data;
        if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
          this.setState({ validationErrors: serverErrors, isSubmitting: false });
        } else {
          this.setState({
            errorMessage: 'Error actualizando el partner. Por favor verifica los datos.',
            isSubmitting: false
          });
        }
      } else {
        this.setState({
          errorMessage: 'Error de conexión. Por favor intenta nuevamente.',
          isSubmitting: false
        });
      }
    });
  };

  defaultIfEmpty = value => {
    return value === "" ? "" : value;
  };

  handleIngresoDateChange = (date) => {
    this.setState({ ingreso_date: date });
  };

  handleCumpleDateChange = (date) => {
    this.setState({ cumple_date: date });
  };

  onChangeNumber = e => {
    const name = e.target.name;
    let value = e.target.value;

    if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
      this.setState({ [name]: value, errorMessage: '' });
    } else {
      this.setState({ errorMessage: 'Invalid decimal number format' });
    }
  };

  render() {

    const { errorMessage,
      ingreso_date,
      cumple_date,
      validationErrors,
      isSubmitting } = this.state;

    return (
      <Form onSubmit={this.props.partner ? this.editPartner : this.createPartner}>
        <p style={{ fontSize: '0.9em', color: '#007bff', marginBottom: '1rem' }}>
          Los campos marcados con <span style={{ color: 'red' }}>*</span> son obligatorios
        </p>

        <FormGroup>
          <Label for="partner">Nombre de miembro: <span style={{ color: 'red' }}>*</span></Label>
          <Input
            type="text"
            name="partner"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.partner)}
            invalid={!!validationErrors.partner}
          />
          {validationErrors.partner && (
            <div className="invalid-feedback d-block">{validationErrors.partner}</div>
          )}
          {this.props.partner && (
            <small className="form-text text-muted">
              Si cambias el nombre, se actualiza automáticamente en todos los proyectos,
              instructores, utilidades y comisiones donde aparece.
            </small>
          )}
        </FormGroup>
        <FormGroup>
          <Label for="email">Correo:</Label>
          <Input
            type="email"
            name="email"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.email)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="nivel">Nivel:</Label>
          <Input
            type="text"
            name="nivel"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.nivel)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="grupo">Grupo:</Label>
          <Input
            type="text"
            name="grupo"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.grupo)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="localizacion">Localizacion:</Label>
          <Input
            type="text"
            name="localizacion"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.localizacion)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="iva">IVA:</Label>
            <Input
                type="text"
                name="iva"
                onChange={this.onChangeNumber}
                value={this.defaultIfEmpty(this.state.iva)}
            />
        </FormGroup>
        <FormGroup>
          <Label for="retencion">Retencion IVA:</Label>
            <Input
                type="text"
                name="retencion"
                onChange={this.onChangeNumber}
                value={this.defaultIfEmpty(this.state.retencion)}
            />
        </FormGroup>
        <FormGroup>
          <Label for="isr">Retencion ISR:</Label>
            <Input
                type="text"
                name="isr"
                onChange={this.onChangeNumber}
                value={this.defaultIfEmpty(this.state.isr)}
            />
        </FormGroup>
        <FormGroup>
          <Label for="ingreso_date">Fecha Ingreso:</Label>
          <DatePicker
            name="ingreso_date"
            selected={ingreso_date}
            onChange={this.handleIngresoDateChange}
            dateFormat="dd/MM/yyyy"
            placeholderText="Selecciona fecha de ingreso"
            className="form-control"
            value={this.defaultIfEmpty(this.state.ingreso_date)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="cumple_date">Cumpleaños:</Label>
          <DatePicker
            name="cumple_date"
            selected={cumple_date}
            onChange={this.handleCumpleDateChange}
            dateFormat="dd/MM/yyyy"
            placeholderText="Selecciona fecha de cumpleaños"
            className="form-control"
            value={this.defaultIfEmpty(this.state.cumple_date)}
          />
        </FormGroup>

        {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

        <Button color="primary" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <Spinner size="sm" className="me-2" /> Guardando...
            </>
          ) : (
            this.props.partner ? "Actualizar Partner" : "Crear Partner"
          )}
        </Button>
      </Form>
    );
  }
}

export default NewPartnerForm;
